import CellPhoto from './CellPhotoContainer';

export default CellPhoto;
